<ng-template #contentHeaderTemplate></ng-template>

<app-table
  id="dashboard.time-tracking.public-holidays.index"
  [showEditLink]="false"
></app-table>
